import smoothscroll from 'smoothscroll-polyfill';

const addScript = (url) => {
	const script = document.createElement('script');
	script.src = url;
	script.async = true;
	document.body.appendChild(script);
};

export const onClientEntry = () => {
	smoothscroll.polyfill();
	// add toProperCase() function to String - returns string as title case
	String.prototype.toProperCase = function () {
		return this.replace(/\w\S*/g, function (txt) {
			return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
		});
	};

	// intercom live chat lib
	(function () {
		var w = window;
		var ic = w.Intercom;
		if (typeof ic === 'function') {
			ic('reattach_activator');
			ic('update', w.intercomSettings);
		} else {
			var d = document;
			var i = function () {
				i.c(arguments);
			};
			i.q = [];
			i.c = function (args) {
				i.q.push(args);
			};
			w.Intercom = i;
			var l = function () {
				var s = d.createElement('script');
				s.type = 'text/javascript';
				s.async = true;
				s.src = `https://widget.intercom.io/widget/${process.env.GATSBY_INTERCOM_KEY}`;
				var x = d.getElementsByTagName('script')[0];
				x.parentNode.insertBefore(s, x);
			};
			if (w.attachEvent) {
				w.attachEvent('onload', l);
			} else {
				w.addEventListener('load', l, false);
			}
		}
	})();

	// Nextdoor Tracking
	(function (win, doc, sdk_url) {
		if (win.ndp) return;
		var tr = (win.ndp = function () {
			tr.handleRequest
				? tr.handleRequest.apply(tr, arguments)
				: tr.queue.push(arguments);
		});
		tr.queue = [];
		var s = 'script';
		var new_script_section = doc.createElement(s);
		new_script_section.async = !0;
		new_script_section.src = sdk_url;
		var insert_pos = doc.getElementsByTagName(s)[0];
		insert_pos.parentNode.insertBefore(new_script_section, insert_pos);
	})(
		window,
		document,
		'https://protect-us.mimecast.com/s/33fuClYPOVT2k9pGsYXKAN?domain=ads.nextdoor.com'
	);

	// Adform
	window._adftrack = Array.isArray(window._adftrack)
		? window._adftrack
		: window._adftrack
			? [window._adftrack]
			: [];
	window._adftrack.push({ HttpHost: 'a2.adform.net', pm: 2427813 });
	(function () {
		var s = document.createElement('script');
		s.type = 'text/javascript';
		s.async = true;
		s.src =
			'https://protect-us.mimecast.com/s/TVEaCrk60NF86NoMI6QrFG?domain=s2.adform.net';
		var x = document.getElementsByTagName('script')[0];
		x.parentNode.insertBefore(s, x);
	})();

	window.onload = () => {
		addScript('https://cdn.weglot.com/weglot.min.js');
		setTimeout(() => {
			window.Weglot?.initialize({
				api_key: process.env.GATSBY_WEGLOT_KEY,
				hide_switcher: true,
				cache: true,
			});
		}, 1500);

		window.intercomSettings = {
			app_id: process.env.GATSBY_INTERCOM_KEY,
		};

		window.ndp('init', process.env.GATSBY_NEXTDOOR_ID, {});
		window.ndp('track', 'PAGE_VIEW');
	};
};
